import axios from "axios";
import { authHeader } from "../authservice/auth-header";

const API_URL = process.env.VUE_APP_ROOT_API
class SuperAdminService {
  // KIOSK LIST RELATED APIs

  // Get Kiosk  List
  getKioskStatus() {
    return axios
      .get(API_URL + "user/spa/kiosk", {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // MENU RELATED APIs

  // Get Menu Header Images
  getMenuHeaderImages() {
    return axios
      .get(API_URL + "hotel/spa/directory-header-image", {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Add Menu Header Images
  addMenuHeaderImage(data) {
    return axios
      .post(API_URL + "hotel/spa/directory-header-image", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Update Hotel Directory Menu page
  updateMenuHeaderImage(header_image_id, data) {
    return axios
      .patch(
        API_URL + "hotel.spa/directory-header-image/" + header_image_id,
        data,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }
  // Delete Hotel Directory Menu page
  deleteMenuHeaderImage(header_image_id) {
    return axios
      .delete(API_URL + "hotel/spa/directory-header-image/" + header_image_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // HOTELS RELATED APIS

  // Get Hotel List
  async getHotelsList(filter = "") {
    const response = await axios.get(API_URL + "hotel/spa/hotel" + filter, {
      headers: authHeader(),
    });
    return response.data.results;
  }

  // add Hotel
  async addHotel(data) {
    const response = await axios.post(API_URL + "hotel/spa/hotel", data, {
      headers: authHeader(),
    });
    return response.data;
  }
  // update Hotel
  async updateHotel(hotel_id, data) {
    const response = await axios.patch(
      API_URL + "hotel/spa/hotel/" + hotel_id,
      data,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }

  //  filter hotel data
  async filtetrHotel(filter = "") {
    const response = await axios.get(
      API_URL + "hotel/spa/hotel-filter" + filter,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }

  // Sync Near By places based on hotel
  async getNearByPlaces(hotel_id) {
    const response = await axios.get(
      API_URL + `hotel/spa/hotel/${hotel_id}/nearby-place-sync`,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }

  // PMS RELATED APis

  // get pms connection list
  async gePMSConnList(filter = "") {
    const response = await axios.get(
      API_URL + "hotel-setting/spa/pms-connection" + filter,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }

  // add pms connection
  async addPMSConn(data) {
    const response = await axios.post(
      API_URL + "hotel-setting/spa/pms-connection",
      data,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }

  // update pms connection
  async updatePMSConn(pms_id, data) {
    const response = await axios.patch(
      API_URL + "hotel-setting/spa/pms-connection/" + pms_id,
      data,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }

  // delete pms connection
  async deletePMSConn(pms_id) {
    const response = await axios.delete(
      API_URL + "hotel-setting/spa/pms-connection/" + pms_id,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }

  // PBX RELATED APis

  // get pbx connection list
  async getPBXConnList(filter = "") {
    const response = await axios.get(
      API_URL + "hotel-setting/spa/pbx-connection" + filter,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }

  // delete pbx connection
  async deletePBXConn(pbx_id) {
    const response = await axios.delete(
      API_URL + "hotel-setting/spa/pbx-connection/" + pbx_id,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }

  // HOTEL ADMIN USER RELATED APIs

  // Get Hotel Admin User List
  getHotelUserList() {
    return axios
      .get(API_URL + "user/spa/hotel-admin", {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data.results;
      });
  }
  // Add Hotel Admin User
  async addHotelUser(data) {
    const response = await axios.post(API_URL + "user/spa/hotel-admin", data, {
      headers: authHeader(),
    });
    return response.data;
  }
  //Edit Hotel Admin User
  async editHotelUser(id, data) {
    const response = await axios.patch(
      API_URL + "user/spa/hotel-admin/" + id,
      data,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }
  // Delete Hotel Admin User
  async deleteHotelUser(id) {
    const response = await axios.delete(
      API_URL + "user/spa/hotel-admin/" + id,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }

  // CDX AND PBX USER RELATED APIs

  // Get cdx and pbx user list
  getCdxUserList() {
    return axios
      .get(API_URL + "user/spa/user/pbx-admin-staff", {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data.results;
      });
  }
  // Add cdx and pbx User
  addCdxUser(data) {
    const response = axios
      .post(API_URL + "user/spa/user/pbx-admin-staff", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //Edit cdx and pbx User
  editCdxUser(id, data) {
    const response = axios
      .patch(API_URL + "user/spa/user/pbx-admin-staff/" + id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Delete cdx and pbx User
  deleteCdxUser(id) {
    const response = axios
      .delete(API_URL + "user/spa/user/pbx-admin-staff/" + id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // HOTEL RESELLER RELATED APIs

  // Get Hotel Reseller List
  getHotelResellerList() {
    return axios
      .get(API_URL + "user/spa/user/pbx-reseller", {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data.results;
      });
  }
  // Add Hotel Reseller User
  async addHotelReseller(data) {
    const response = await axios.post(
      API_URL + "user/spa/user/pbx-reseller",
      data,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }
  // Edit Hotel Reseller User
  async editHotelReseller(id, data) {
    const response = await axios.patch(
      API_URL + "user/spa/user/pbx-reseller/" + id,
      data,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }
  // Delete Hotel Reseller User
  async deleteHotelReseller(id) {
    const response = await axios.delete(
      API_URL + "user/spa/user/pbx-reseller/" + id,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }

  // APP FEATURE RELATED APIs

  // Get app user feature
  async getAppFeature() {
    const response = await axios.get(API_URL + "app-setting/spa/app-feature", {
      headers: authHeader(),
    });
    return response.data;
  }
  // Add App Feature Data
  async addAppFeature(data) {
    const response = await axios.post(
      API_URL + "app-setting/spa/app-feature",
      data,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }
  //Edit App Feature Theme Data
  async editAppFeature(app_id, data) {
    const response = await axios.patch(
      API_URL + "app-setting/spa/app-feature/" + app_id,
      data,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }

  // BRAND RELATED APIs

  // Get Brand Data
  async getBrandData() {
    const response = await axios.get(API_URL + "hotel/spa/brand", {
      headers: authHeader(),
    });
    return response.data;
  }
  // Add Brand Data
  async addBrandData(data) {
    const response = await axios.post(API_URL + "hotel/spa/brand", data, {
      headers: authHeader(),
    });
    return response.data;
  }
  //Edit Brand Data
  async editBrandData(id, data) {
    const response = await axios.patch(
      API_URL + "hotel/spa/brand/" + id,
      data,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }

  // BRAND THEME RELATED APIs

  // Get Brand Theme Data
  async getBrandThemeData(id) {
    const response = await axios.get(
      API_URL + "hotel/spa/brand/" + id + "/theme",
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }
  // Add Brand Theme Data
  async addBrandThemeData(id, data) {
    const response = await axios.post(
      API_URL + "hotel/spa/brand/" + id + "/theme",
      data,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }
  // Edit Brand Theme Data
  async editBrandThemeData(id, newId, data) {
    const response = await axios.patch(
      API_URL + "hotel/spa/brand/" + id + "/theme/" + newId,
      data,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }
  // Delete Brand Theme Data
  async deleteBrandThemeData(brand_id, theme_id) {
    const response = await axios.delete(
      API_URL + "hotel/spa/brand/" + brand_id + "/theme/" + theme_id,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }

  //LOCK IOT GATEWAY RELATED APIs

  // Get gateway list
  async getGatewayList(filter = "") {
    const response = await axios.get(API_URL + "iot/gateway" + filter, {
      headers: authHeader(),
    });
    return response.data;
  }
  // Add gateway Data
  async addGateway(data) {
    const response = await axios.post(API_URL + "iot/gateway", data, {
      headers: authHeader(),
    });
    return response.data;
  }
  // Edit Gateway Data
  async editGateWayData(gateway_id, data) {
    const response = await axios.patch(
      API_URL + "iot/gateway/" + gateway_id,
      data,
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }
  // Delete gateway
  async deleteGateway(gateway_id) {
    const response = await axios.delete(API_URL + "iot/gateway/" + gateway_id, {
      headers: authHeader(),
    });
    return response.data;
  }
}
export default new SuperAdminService();
